// extracted by mini-css-extract-plugin
export const description = "portfolio-module--description--3h_Ur";
export const companiesHeading = "portfolio-module--companiesHeading--26M_5";
export const companiesHeader = "portfolio-module--companiesHeader--2uWV0";
export const portfolioFilterSelect = "portfolio-module--portfolioFilterSelect--3IRZI";